import { useCallback, useState } from 'react';
import { Card, CardContent } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { Form, Formik } from 'formik';
import { motion } from 'framer-motion';

// local imports
import { CampaignCrudForm } from 'app/components/organisms/forms';
import { EnvDefaults, FormatUtils, ValidationSchema } from 'app/utils';
import { CampaignService } from 'app/services';
import { useStateCallback } from 'app/hooks';
import { cancelRequests } from 'app/utils/axios';

const CampaignAdd = () => {
  const history = useHistory();
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [loading, setLoading] = useStateCallback(false);

  // stop upload photo and cancel current request
  const removeFile = () => cancelRequests('Request Cancelled!');

  // submit form
  const handleSubmit = useCallback(
    async values => {
      const { start_date, end_date, ...rest } = values;
      const valueToUse = {
        ...rest,
        start_date: FormatUtils.convertPostDate(start_date),
        end_date: FormatUtils.convertPostDate(end_date)
      };

      setLoading(true, async () => {
        const serviceFn = () => CampaignService.addCampaign(valueToUse);
        try {
          const data = await serviceFn();
          const campaignId = data?.data?.data;

          setTimeout(() => {
            history.push('/campaign-management/campaign-pharmacies', { id: campaignId });
          }, 1000);
        } catch (err) {
          console.log('Error -> ', err);
        } finally {
          setLoading(false);
        }
      });
    },
    [setLoading, history]
  );

  return (
    <>
      <motion.div initial={{ scale: 0, opacity: 0.2 }} animate={{ scale: 1, opacity: 1 }}>
        <Card elevation={4}>
          <CardContent>
            <Formik
              enableReinitialize
              initialValues={EnvDefaults.addEditCampaignDefaults}
              validationSchema={ValidationSchema.campaignCrudSchema(false)}
              onSubmit={handleSubmit}>
              <Form>
                <CampaignCrudForm
                  loading={loading}
                  selectedFiles={selectedFiles}
                  setSelectedFiles={setSelectedFiles}
                  removeFile={removeFile}
                />
              </Form>
            </Formik>
          </CardContent>
        </Card>
      </motion.div>
    </>
  );
};

export default CampaignAdd;
